export class CartModel {
  constructor(public count: number, public cost: number) {}
}
